import React, {useContext} from 'react';
import './style.scss';
import PropTypes from "prop-types";
import {getSocialLinkByName} from "../../../helpers";
import {brandContext} from "../../../store/brandContext";
import {BRANDS} from "../../../common";

/**
 * Социальные сети
 *
 * @param {Object} props
 * @param {Array} [props.links=['vk','instagram']] Массив иконок соц сетей
 * @param {String} [props.lang='ru'] Страна для подстановки соц сетей
 * @param {String} [props.target=blank] Параметр для открытия ссылок
 * @returns {JSX.Element}
 * @constructor
 */
const SocialLinks = ({links, lang, target}) => {
  const brandName = useContext(brandContext);
  const renderLink = item => {
    const link = getSocialLinkByName(item);
    return link && link[brandName][lang] &&
      <a
        key={link.id}
        className='social-links-wrapper__link'
        href={link[brandName][lang]}
        target={target}
        dangerouslySetInnerHTML={{__html: link.img}}
      />
  }

  return (
    <div className={`social-links-wrapper social-links-wrapper-${lang} social-links-wrapper-${brandName} social-links-wrapper-${brandName}-${lang}`}>
      {links.map(item => renderLink(item))}
    </div>
  )
}

SocialLinks.propTypes = {
  links: PropTypes.array,
  lang: PropTypes.string,
  target: PropTypes.string
};

SocialLinks.defaultProps = {
  links: ['telegram'],
  lang: 'ru',
  target: 'blank'
};

export default SocialLinks



